/**
 * 操作日志「系统模块」title 与 i18n 键映射（后端 @Log(title) 写入为中文）
 */
const OPERLOG_TITLE_MAP = {
  '日活统计': 'monitor.operlog.titleDailyActivity',
  '参数管理': 'monitor.operlog.titleConfig',
  '通知公告': 'monitor.operlog.titleNotice',
  '新增短剧': 'monitor.operlog.titleVideoAdd',
  '编辑短剧': 'monitor.operlog.titleVideoEdit',
  '删除短剧': 'monitor.operlog.titleVideoDelete',
  '导出短剧': 'monitor.operlog.titleVideoExport',
  '视频导入': 'monitor.operlog.titleVideoImport',
  '导出用户列表': 'monitor.operlog.titleUserExport',
  '编辑是否开启': 'monitor.operlog.titleToggleStatus',
  '编辑短剧排序': 'monitor.operlog.titleVideoSort',
  '新增帮助中心': 'monitor.operlog.titleHelpAdd',
  '编辑帮助中心': 'monitor.operlog.titleHelpEdit',
  '删除帮助中心': 'monitor.operlog.titleHelpDelete',
  '新增手机区号': 'monitor.operlog.titleMobileCodeAdd',
  '编辑手机区号': 'monitor.operlog.titleMobileCodeEdit',
  '删除手机区号': 'monitor.operlog.titleMobileCodeDelete',
  '导出手机区号': 'monitor.operlog.titleMobileCodeExport',
  '新增引导页': 'monitor.operlog.titleGuideAdd',
  '编辑引导页': 'monitor.operlog.titleGuideEdit',
  '删除引导页': 'monitor.operlog.titleGuideDelete',
  '导出引导页': 'monitor.operlog.titleGuideExport',
  '新增用户头像': 'monitor.operlog.titleAvatarAdd',
  '编辑用户头像': 'monitor.operlog.titleAvatarEdit',
  '删除用户头像': 'monitor.operlog.titleAvatarDelete',
  '导出用户头像': 'monitor.operlog.titleAvatarExport',
  '新增敏感词': 'monitor.operlog.titleWordsAdd',
  '编辑敏感词': 'monitor.operlog.titleWordsEdit',
  '删除敏感词': 'monitor.operlog.titleWordsDelete',
  '导出敏感词': 'monitor.operlog.titleWordsExport',
  '新增广告': 'monitor.operlog.titleAdAdd',
  '编辑广告': 'monitor.operlog.titleAdEdit',
  '删除广告': 'monitor.operlog.titleAdDelete',
  '导出广告': 'monitor.operlog.titleAdExport',
  '会员下单': 'monitor.operlog.titleVipOrder',
  '会员绑定用户': 'monitor.operlog.titleVipBind',
  '充值下单': 'monitor.operlog.titleRechargeOrder',
  '新增钻石充值订单': 'monitor.operlog.titleRechargeAdd',
  '编辑钻石充值订单': 'monitor.operlog.titleRechargeEdit',
  '删除钻石充值订单': 'monitor.operlog.titleRechargeDelete',
  '新增邀请用户奖励配置': 'monitor.operlog.titleInviteRewardAdd',
  '编辑邀请用户奖励配置': 'monitor.operlog.titleInviteRewardEdit',
  '新增常见问题': 'monitor.operlog.titleProblemAdd',
  '编辑常见问题': 'monitor.operlog.titleProblemEdit',
  '编辑常见问题状态': 'monitor.operlog.titleProblemStatus',
  '删除常见问题': 'monitor.operlog.titleProblemDelete',
  '导出常见问题': 'monitor.operlog.titleProblemExport',
  '新增视频演员': 'monitor.operlog.titlePerformerAdd',
  '编辑视频演员': 'monitor.operlog.titlePerformerEdit',
  '删除视频演员': 'monitor.operlog.titlePerformerDelete',
  '用户日活统计': 'monitor.operlog.titleUserDailyActivity'
}

/**
 * @param {string} title 日志中的模块名称（中文）
 * @param {Function} t vue-i18n 的 $t
 */
export function formatOperlogTitle (title, t) {
  if (title == null || title === '') {
    return ''
  }
  const key = OPERLOG_TITLE_MAP[title]
  if (key) {
    const text = t(key)
    if (text && text !== key) {
      return text
    }
  }
  return title
}

export default formatOperlogTitle
